import * as types from "./actionTypes";

const initialState = {
  loading: false,
  isSuccess: false,
  isError: false,
  payload: {},
  error: null
};

export default function rolesReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_ROLES_LOADING:
      return {
        ...state,
        loading: true
      };
    case types.GET_ROLES_SUCCESS:
      return {
        ...state,
        loading: false,
        isSuccess: true,
        error: null,
        payload: action.payload
      };
    case types.GET_ROLES_FAILURE:
      return {
        ...state,
        payload: {},
        loading: false,
        isError: true,
        error: action.payload
      };

    case types.LOGOUT_LOADING:
      return {
        ...state,
        loading: true
      };
    case types.LOGOUT_SUCCESS:
      return {
        ...state,
        loading: false,
        isSuccess: true,
        error: null,
        payload: action.payload
      };
    case types.LOGOUT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
}
